// 🔧 使用项目统一的 apiClient（已配置JWT认证）
import apiClient from './client';

export interface FeishuTitleResult {
  url: string;
  title: string | null;
  success: boolean;
  error?: string;
}

export interface FeishuTitleParseResponse {
  results: FeishuTitleResult[];
  summary: {
    total: number;
    success_count: number;
    failed_count: number;
  };
}

/**
 * 批量解析飞书文档标题（通过BSP后端代理到BVP后端）
 *
 * @param urls 飞书文档URL数组
 * @returns 解析结果，包括标题和成功/失败状态
 */
export const parseFeishuTitles = async (
  urls: string[]
): Promise<FeishuTitleParseResponse> => {
  // 过滤空URL和非字符串
  const validUrls = urls.filter(url => url && typeof url === 'string');

  if (validUrls.length === 0) {
    return {
      results: [],
      summary: {
        total: 0,
        success_count: 0,
        failed_count: 0,
      },
    };
  }

  try {
    // 🔧 使用 apiClient 调用BSP后端（自动携带JWT认证）
    const response = await apiClient.post<FeishuTitleParseResponse>(
      '/requirements/feishu/parse-titles',  // 相对路径，apiClient已配置baseURL
      { urls: validUrls }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to parse Feishu titles:', error);
    // 返回降级数据（服务不可用时）
    return {
      results: validUrls.map(url => ({
        url,
        title: null,
        success: false,
        error: 'BSP服务不可用',  // 🔧 修改错误信息
      })),
      summary: {
        total: validUrls.length,
        success_count: 0,
        failed_count: validUrls.length,
      },
    };
  }
};
